import { UserManager, WebStorageStateStore } from "oidc-client-ts";
import { getWorkchestraOrigin } from "./utils";

const BASE_URL = window.location.origin;
// Trailing slash must be stripped: IdentityServer matches redirect_uri by
// exact string against the registered RedirectUris, which are registered
// without one (see IdentityServerConfiguration.cs).
const AEROTRAK_BASE_URL = import.meta.env.VITE_AEROTRAK_BASE_URL?.replace(
  /\/$/,
  ""
);
// Fallback to <origin>/callback when VITE_AEROTRAK_BASE_URL is not configured
const REDIRECT_URI = AEROTRAK_BASE_URL || `${BASE_URL}/callback`;
// Use VITE_WORKCHESTRA_BASE_URL (remove trailing slash) or fallback to localhost
const BACKEND_URL = getWorkchestraOrigin() || "https://localhost:44311";

/**
 * OIDC Configuration for Standalone Mode
 * This configuration is used when the React app runs independently from the Angular app.
 */
export const oidcConfig = {
  authority: BACKEND_URL,
  client_id: 'workchestra-pps-react', // Standalone client ID configured in IdentityServer
  redirect_uri: REDIRECT_URI,
  post_logout_redirect_uri: `${BASE_URL}`,
  response_type: "code",
  scope: "openid profile WorkchestraWebAppAPI",

  // Use session storage for tokens (consistent with current implementation)
  userStore: new WebStorageStateStore({ store: window.sessionStorage }),

  // Auto renew tokens before they expire
  automaticSilentRenew: true,
  silent_redirect_uri: `${BASE_URL}/silent-renew.html`,

  // Enable PKCE for better security
  code_challenge_method: "S256" as const,

  // Load user info from userinfo endpoint
  loadUserInfo: true,

  // Additional settings
  monitorSession: true,
  checkSessionInterval: 2000,
};

/**
 * User Manager instance for handling OIDC operations
 */
export const userManager = new UserManager(oidcConfig);

/**
 * Setup event handlers for user manager
 */
userManager.events.addUserLoaded((user) => {
  console.log("User loaded:", user.profile.name);
});

userManager.events.addUserUnloaded(() => {
  console.log("User unloaded");
});

userManager.events.addAccessTokenExpiring(() => {
  console.log("Access token expiring");
});

userManager.events.addAccessTokenExpired(() => {
  console.log("Access token expired");
});

userManager.events.addSilentRenewError((error) => {
  console.error("Silent renew error:", error);
});
